import { FormattedMessage } from 'react-intl';

import { FormattedCurrency } from '../../../iwIntlProvider/FormattedCurrency';
import RepaymentSummaryItem from '../repaymentSummaryItem/RepaymentSummaryItem';

export const NextRepaymentSummary = ({
    previousNextRepayment,
    interval,
    date,
    amount
}: {
    previousNextRepayment: number | null;
    interval?: string;
    date: string | null;
    amount: number | null;
}) => {
    const renderDescription = () => {
        if (amount === null) {
            return (
                <FormattedMessage
                    id="_.next_repayment_summary.no_further_repayments"
                    defaultMessage="You have no further repayments after that"
                />
            );
        }

        if (previousNextRepayment) {
            return (
                <FormattedMessage
                    id="_.next_repayment_summary.reduced_description"
                    defaultMessage="Compared to your next repayment of {amount}"
                    values={{
                        amount: (
                            <FormattedCurrency value={previousNextRepayment} />
                        )
                    }}
                />
            );
        }

        return (
            <FormattedMessage
                id="_.next_repayment_summary.same_description"
                defaultMessage="Your next repayment stays the same"
            />
        );
    };

    return (
        <RepaymentSummaryItem
            amount={amount}
            description={renderDescription()}
            interval={interval}
            value={date}
        />
    );
};
